import type { MyInvitation, InvitationPublicInfo } from '../types';

export const invitationsMock: MyInvitation[] = [
  {
    id: 'mock-inv-1',
    tenantId: 'mock-tenant-1',
    tenantName: 'Acme Corp',
    tenantAvatarUrl: null,
    membersCount: 12,
    inviterName: 'Carlos López',
    role: 'collaborator',
    createdAt: '2024-01-15T10:00:00Z',
    expiresAt: '2024-02-15T10:00:00Z',
  },
  {
    id: 'mock-inv-2',
    tenantId: 'mock-tenant-2',
    tenantName: 'Beta Studio',
    tenantAvatarUrl: null,
    membersCount: 4,
    inviterName: 'Ana García',
    role: 'admin',
    createdAt: '2024-01-20T09:30:00Z',
    expiresAt: '2024-02-20T09:30:00Z',
  },
];

export const invitationPublicInfoMock: InvitationPublicInfo = {
  id: 'mock-inv-1',
  tenantId: 'mock-tenant-1',
  tenantName: 'Acme Corp',
  email: 'invitee@example.com',
  role: 'collaborator',
  createdAt: '2024-01-15T10:00:00Z',
  expiresAt: '2024-02-15T10:00:00Z',
  isValid: true,
};
